define('home/templates/profileCommentsModule',['handlebars', 'handlebars.partials', 'core/extensions/handlebars.helpers'], function(Handlebars) {

return Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var alias1=depth0 != null ? depth0 : {}, alias2=container.escapeExpression;

  return "<header class=\"module-header text-center\">\n<div class=\"module-header__icon\">\n<span class=\"icon icon-latest-comments text-brand\"></span>\n</div>\n<div class=\"module-header__title\">\n<h2 class=\"module-header__heading\">"
    + alias2(helpers.gettext.call(alias1,"Latest Comments",{"name":"gettext","hash":{},"data":data}))
    + "</h2>\n</div>\n</header>\n\n<div data-role=\"posts\" class=\"module-body\"></div>\n\n<footer data-action=\"switch-tab\" data-tab=\"comments\" class=\"module-footer\">\n<a href=\"/by/"
    + alias2(container.lambda((depth0 != null ? depth0.username : depth0), depth0))
    + "/comments/\" class=\"nav-lnk -color-muted -flushed\">\n<div class=\"nav-lnk__blk\">"
    + alias2(helpers.gettext.call(alias1,"See All Comments",{"name":"gettext","hash":{},"data":data}))
    + "</div>\n<div class=\"nav-lnk__pointer\">\n<span class=\"icon icon-right-bracket\"></span>\n</div>\n</a>\n</footer>\n";
},"useData":true})

});
